

export const buildBenchFromState = (state) => {
    return buildBenchFromOptions(
        state.benchModel.model.name,
        state.benchModel.shape.code,
        state.benchModel.shape.mirrored || state.benchModel.mirrored,
        state.benchModel.material,
        state.benchModel.profileMaterial,
        state.measurements
     );
};
export const buildBenchFromOptions = (brand, shape, mirrored,material, profileMaterial, measurements) => {
    let stovePosition = convertStovePosition(measurements)
    return {
        saunaDebth: measurements.depth,
        saunaWidth: measurements.doorWallWidth,
        doorWidth: measurements.doorWidth,
        stoveWall: stovePosition.stoveWall,
        stoveFromLeft: parseInt(stovePosition.stoveFromLeft) || 0,
        visulizationModel: shape,
        benchBrand: brand.replace("relax XL", "relax"),
        materialId: material,
        profileMaterialId: profileMaterial,
        mirrored: mirrored
    };
};

let convertStovePosition = (measurements) => {
    let distanceToleftWall = measurements.stovePosition.x;
    let distanceToRightWall = measurements.doorWallWidth - measurements.stovePosition.x;
    let distanceToBackWall = measurements.stovePosition.y;
    let distanceToFrontWall = measurements.depth - measurements.stovePosition.y;
    let smallestDistance = Math.min(distanceToleftWall, distanceToRightWall, distanceToBackWall, distanceToFrontWall);
    let result = {};
    if (distanceToFrontWall === smallestDistance) {
        result.stoveWall = "front";
        result.stoveFromLeft = distanceToRightWall;
    }
    else if (distanceToleftWall === smallestDistance) {
        result.stoveWall = "left";
        result.stoveFromLeft = distanceToFrontWall;
    }
    else if (distanceToRightWall === smallestDistance) {
        result.stoveWall = "right";
        result.stoveFromLeft = distanceToBackWall;
    }
    else {
        result.stoveWall = "back";
        result.stoveFromLeft = distanceToRightWall;
    }
    return result;
}